<section class="wrap-contact-box">
  <div class="layout">
    <div class="left d-flex flex-column align-items-center">
      <h1 class="subtitle">Contato</h1>
      <p>Fale com a gente por meio de um dos nossos canais:</p>
      <figure class="fig">
        <img
          src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/fig-contato.png"
          alt="Contato"
          loading="lazy"
        />
      </figure>
      <div class="horario-atendimento">
        <h2 class="heading-subtitle"><strong>Horário de Funcionamento:</strong></h2>
        <ul>
          <li><strong>Segunda-feira a quinta-feira:</strong> 8h às 18h</li>
          <li><strong>Sexta-feira:</strong> 8h às 17h</li>
          <li><strong>Sábado:</strong> 8h às 12h</li>
        </ul>
      </div>
    </div>
    <div appAppearRightOnScroll class="right">
      <div *ngIf="emailEnviado" class="box-form">
        <div class="ckeditor">
          <p>
            <strong
              >Contato enviado com sucesso. Em breve nossa equipe estará
              entrando em contato</strong
            >
          </p>
        </div>
        <br />
        <hr />
        <br />
        <button (click)="enviarOutro()" class="btn gradient">
          Enviar um novo contato
        </button>
      </div>
      <div *ngIf="!emailEnviado" class="box-form">
        <div class="ckeditor">
          <p>
            <strong
              >Preencha os dados abaixo que nossa equipe entrará em contato com
              você:</strong
            >
          </p>
        </div>
        <form
          (ngSubmit)="onSubmit()"
          class="d-flex flex-column"
          #contactForm="ngForm"
          novalidate
        >
          <div class="form-group">
            <input
              aria-label="nome"
              type="text"
              id="nome"
              name="nome"
              [(ngModel)]="form.nome"
              class="form-control"
              placeholder="Seu nome"
              required
              maxlength="400"
              
            />
          </div>
          <div class="form-group">
            <input
              aria-label="email"

              type="email"
              id="email"
              name="email"
              [(ngModel)]="form.email"
              class="form-control"
              placeholder="Seu e-mail"
              required
              maxlength="400"
            />
          </div>
          <div class="form-group">
            <input
              aria-label="empresa"

              type="text"
              id="empresa"
              name="empresa"
              [(ngModel)]="form.empresa"
              class="form-control"
              placeholder="Sua empresa"
              required
              maxlength="400"
            />
          </div>
          <div class="form-group">
            <input
              aria-label="celular"

              type="text"
              id="celular"
              name="celular"
              [(ngModel)]="form.telefone"
              class="form-control"
              placeholder="Seu celular"
              required
              maxlength="400"
            />
          </div>
          <div class="form-group">
            <select
              aria-label="assunto"

              id="assunto"
              name="assunto"
              [(ngModel)]="form.assunto"
              class="form-control"
              required
            >
              <option value="" disabled selected>Selecione o assunto</option>
              <option value="Suporte">
                Sou cliente e preciso falar com Suporte
              </option>
              <option value="Comercial">
                Comercial - Quero conhecer as soluções
              </option>
              <option value="Marketing">Quero falar com Marketing</option>
            </select>
          </div>
          <div class="form-group">
            <textarea
              aria-label="mensagem"

              id="mensagem"
              name="mensagem"
              [(ngModel)]="form.mensagem"
              class="form-control"
              placeholder="Mensagem"
              rows="4"
              required
              maxlength="2000"
            ></textarea>
          </div>
          <button
            type="submit"
            class="btn gradient"
            [disabled]="contactForm.invalid"
          >
            Enviar Mensagem
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
